import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRef } from 'react';
import './MunicipalityMap.scss';
export const MunicipalityMap = ({ className, knr }) => {
    const overlayPolygonRef = useRef(null);
    const overlayOutlineRef = useRef(null);
    const blipperRef = useRef(null);
    const blipper_px_width = window.matchMedia("max-width: 480px") ? 120 : 180;
    const blipper_px_height = blipper_px_width;
    if (/^\d{4}$/.test(knr !== null && knr !== void 0 ? knr : '')) {
        fetch(`https://cdn.stage.kommunal-rapport.dev/omriss/${knr}.svg`)
            .then((res) => {
            return res.status === 200 ? res.text() : null;
        })
            .then((svgStr) => {
            if (svgStr !== null && overlayOutlineRef.current) {
                svgStr = svgStr.replace(/fill:#[0-9a-f]{6}; stroke:#[0-9a-f]{6}; stroke-width:[0-9.]+; /g, '');
                overlayOutlineRef.current.innerHTML = '';
                const parser = new DOMParser();
                const svgEle = parser.parseFromString(svgStr, 'image/svg+xml').documentElement;
                overlayOutlineRef.current.appendChild(svgEle);
            }
        });
        const recalc = (json) => {
            if (json !== null && overlayPolygonRef.current) {
                const svgStr = json.svg.replaceAll('fill:#ff0000; stroke:#ff0000; ', '');
                const center = json.center;
                const map = document.querySelector('.muni-map-layers');
                const map_css_overlay_margin_x = 0;
                const map_px_width = ((map === null || map === void 0 ? void 0 : map.clientWidth) || 0);
                const map_px_height = ((map === null || map === void 0 ? void 0 : map.clientHeight) || 0);
                overlayPolygonRef.current.innerHTML = '';
                const parser = new DOMParser();
                const svgEle = parser.parseFromString(svgStr, 'image/svg+xml').documentElement;
                const vb = { minX: 0, minY: 0, width: 0, height: 0 };
                const vbDimensions = svgEle.getAttribute('viewBox');
                if (vbDimensions) {
                    [vb.minX, vb.minY, vb.width, vb.height] = (vbDimensions || '').trim().split(/\s+|,/).map(Number);
                }
                const viewbox_offset_x = Math.abs(vb.minX);
                const domain_factor_x = map_px_width / vb.width;
                const domain_factor_y = map_px_height / vb.height;
                const blipper_x = map_css_overlay_margin_x + ((parseFloat(center.x) + viewbox_offset_x) * domain_factor_x) - (blipper_px_width / 2);
                const blipper_y = Math.abs((parseFloat(center.y) + vb.minY) * domain_factor_y) - (blipper_px_height / 2);
                if (blipperRef.current !== null) {
                    blipperRef.current.classList.remove('blip');
                    blipperRef.current.setAttribute('style', `left: ${blipper_x}px; top: ${blipper_y}px;`);
                    setTimeout(() => {
                        var _a;
                        (_a = blipperRef.current) === null || _a === void 0 ? void 0 : _a.classList.add('blip');
                    }, 750);
                }
                overlayPolygonRef.current.appendChild(svgEle);
            }
        };
        fetch(`https://cdn.stage.kommunal-rapport.dev/omriss/${knr}_overlay.json`)
            .then((res) => {
            return res.status === 200 ? res.json() : null;
        })
            .then((json) => {
            requestAnimationFrame(() => {
                recalc(json);
            });
        });
    }
    const blipperSize = { width: `${blipper_px_width}px`, height: `${blipper_px_height}px` };
    return (_jsx("div", { className: `page-element municipality-map ${className !== null && className !== void 0 ? className : ''}`, children: _jsxs("figure", { className: "muni-map-layers", children: [_jsx("div", { className: "muni-map-layer basemap", children: _jsx("img", { src: "https://cdn.stage.kommunal-rapport.dev/omriss/landet_kbfront.png" }) }), knr ? _jsxs(_Fragment, { children: [_jsx("div", { className: "muni-map-layer polygon", ref: overlayPolygonRef }), _jsx("div", { className: "muni-map-layer outline", ref: overlayOutlineRef }), _jsx("div", { className: "muni-map-layer blipper", ref: blipperRef, style: blipperSize, children: _jsxs("svg", { id: "blipper", width: blipper_px_width, xmlns: "http://www.w3.org/2000/svg", version: "1.1", viewBox: "0 0 188 188", children: [_jsx("circle", { className: "ring4", cx: "94", cy: "94", r: "90" }), _jsx("circle", { className: "ring3", cx: "94", cy: "94", r: "70" }), _jsx("circle", { className: "ring2", cx: "94", cy: "94", r: "50" }), _jsx("circle", { className: "ring1", cx: "94", cy: "94", r: "30" })] }) })] })
                    : null] }) }));
};
